import React, { useState } from 'react';
import Select from 'components/Form/Select';
import styled from 'styled-components';

const SelectWithLabel = props => {
  const [focused, setFocus] = useState(false);
  const { id, format, placeholder, nameType, values, formValid, formErrors } = props;

  const handleFocus = event => {
    setFocus(true);
    if (props.handleFocus !== undefined) props.handleFocus(id);
  };

  const handleBlur = event => {
    setFocus(false);
    props.handleBlur(id, event.target.value);
  };

  const handleChange = event => {
    props.handleChange(id, event);
  };
  return (
    <div>
      <SelectTitle>
        {focused ? nameType : formValid[id] === -1 ? formErrors[id] : nameType}
      </SelectTitle>
      <Select
        nameType={id}
        handleChange={handleChange}
        placeholder={placeholder}
        formValid={formValid}
        id={id}
        options={props.options}
      />
    </div>
  );
};

const SelectTitle = styled.div`
  font-family: Sofia Pro;
  font-size: 20px;
  font-weight: 600;
  line-height: 23px;
  color: var(--normal-title-color);
  margin-bottom: 16px;
`;

export default SelectWithLabel;
